import i18n from "../../../../i18n";

export const _info = (_mappedMetadata: any) => {
  return [
    ...(_mappedMetadata?.documentsRelationProject && i18n.language === 'el'
      ? [{
        name: 'Τίτλος Έργου',
        value: '',
        refValue: 'documentsRelationProject',
      }] :
      []),
    ...(_mappedMetadata?.documentsEnTitle && i18n.language === 'en'
      ? [{
        name: 'Τίτλος Έργου',
        value: '',
        refValue: 'documentsRelationProjectEn',
      }] :
      []),
    ...(_mappedMetadata?.documentsRelationOrganisation && i18n.language === 'el'
      ? [{
        name: 'Φορέας',
        value: '',
        refValue: 'documentsRelationOrganisation',
      }] :
      []),
    ...(_mappedMetadata?.documentsRelationOrganisationEn && i18n.language === 'en'
      ? [{
        name: 'Φορέας',
        value: '',
        refValue: 'documentsRelationOrganisationEn',
      }] :
      []),
    ...(_mappedMetadata?.documentsRelationCollection && i18n.language === 'el'
      ? [{
        name: 'Συλλογή',
        value: '',
        refValue: 'documentsRelationCollection',
      }] :
      []),
    ...(_mappedMetadata?.documentsRelationCollectionEn && i18n.language === 'en'
      ? [{
        name: 'Συλλογή',
        value: '',
        refValue: 'documentsRelationCollectionEn',
      }] :
      []),
  ];
};

export const _tekmirioInfo = (_mappedMetadata: any) => {
  return [
    ...(_mappedMetadata?.documentsUniqueCode
      ? [{
        name: 'Αναγνωριστικό Τεκμηρίου',
        value: '',
        refValue: 'documentsUniqueCode',
      }] :
      []),
    ...(_mappedMetadata?.documentsType
      ? [{
        name: 'Τύπος Τεκμηρίου',
        value: '',
        refValue: 'documentsType',
      }] :
      []),
    ...(_mappedMetadata?.documentsDescription && i18n.language === 'el'
      ? [{
        name: 'Περιγραφή Τεκμηρίου',
        value: '',
        refValue: 'documentsDescription',
      }] :
      []),
    ...(_mappedMetadata?.documentsEnDescription && i18n.language === 'en'
      ? [{
        name: 'Περιγραφή Τεκμηρίου',
        value: '',
        refValue: 'documentsEnDescription'
      }] :
      []),
    ...(_mappedMetadata?.documentsFormat
      ? [{
        name: 'Μορφότυπο',
        value: '',
        refValue: 'documentsFormat',
      }] :
      []),
    ...(_mappedMetadata?.documentsDuration
      ? [{
        name: 'Διάρκεια',
        value: '',
        refValue: 'documentsDuration',
      }] :
      []),
    ...(_mappedMetadata?.documentsDateCreation
      ? [{
        name: 'Ημερομηνία Δημιουργίας',
        value: '',
        refValue: 'documentsDateCreation',
      }] :
      []),
    ...(_mappedMetadata?.documentsColor
      ? [{
        name: 'Χρώμα',
        value: '',
        refValue: 'documentsColor'
      }] :
      []),
    ...(_mappedMetadata?.documentsSound
      ? [{
        name: 'Ήχος',
        value: '',
        refValue: 'documentsSound',
      }] :
      []),
    ...(_mappedMetadata?.documentsTechnical
      ? [{
        name: 'Τεχνική',
        value: '',
        refValue: 'documentsTechnical',
      }] :
      []),
    ...(_mappedMetadata?.documentsSize
      ? [{
        name: 'Μέγεθος',
        value: '',
        refValue: 'documentsSize',
      }] :
      []),
    ...(_mappedMetadata?.documentsHeight
      ? [{
        name: 'Ύψος',
        value: '',
        refValue: 'documentsHeight'
      }] :
      []),
    ...(_mappedMetadata?.documentsWidth
      ? [{
        name: 'Πλάτος',
        value: '',
        refValue: 'documentsWidth'
      }] :
      []),
    ...(_mappedMetadata?.documentsFrameRate
      ? [{
        name: 'Frame Rate',
        value: '',
        refValue: 'documentsFrameRate',
      }] :
      []),
    ...(_mappedMetadata?.documentsAspectRatio
      ? [{
        name: 'Aspect Ratio',
        value: '',
        refValue: 'documentsAspectRatio',
      }] :
      []),
    ...(_mappedMetadata?.documentsCopyright
      ? [{
        name: 'Copyright',
        value: '',
        refValue: 'documentsCopyright',
      }] :
      []),
    ...(_mappedMetadata?.documentsLicence
      ? [{
        name: 'Άδεια Χρήσης',
        value: '',
        refValue: 'documentsLicence'
      }] :
      []),
    ...(_mappedMetadata?.something
      ? [{
        name: 'Κωδικός Τεκμηρίου',
        value: '',
        refValue: '',
      }] :
      []),
    ...(_mappedMetadata?.something
      ? [{
        name: 'Διάθεση',
        value: '',
        refValue: '',
      }] :
      []),
    ...(_mappedMetadata?.documentsComments
      ? [{
        name: 'Παρατηρήσεις',
        value: '',
        refValue: 'documentsComments'
      }] :
      []),
    ...(_mappedMetadata?.documentsYtTitle
      ? [{
        name: 'Τίτλος Βίντεο',
        value: '',
        refValue: 'documentsYtTitle'
      }] :
      []),
    ...(_mappedMetadata?.documentsYtUrl
      ? [{
        name: 'Video URL',
        value: '',
        refValue: 'documentsYtUrl'
      }] :
      []),
  ];
};

export const _tekmirioFiles = [
  {
    name: 'Τίτλος',
    value: '',
    refValue: 'mediaTitle'
  },
  {
    name: 'Μέγεθος',
    value: '',
    refValue: 'mediaSize'
  },
  {
    name: 'Ύψος',
    value: '',
    refValue: 'mediaHeight'
  },
  {
    name: 'Πλάτος',
    value: '',
    refValue: 'mediaWidth'
  }
];
